module.exports = __webpack_public_path__ + "img/challenge-success.5e251116.png";